export default __webpack_public_path__ + "static/media/attention_yellow.e5316a13.svg";